import chatbotRequest from '@/service/channel/http'
import type { DeleteRoomMessageReq, DeleteRoomMessageRes } from '../type/deleteRoomMessage'

export function deleteRoomMessageApi(data: DeleteRoomMessageReq): Promise<DeleteRoomMessageRes> {
    return chatbotRequest<DeleteRoomMessageRes, DeleteRoomMessageReq, DeleteRoomMessageRes>({
        url: '/api/room/message/delete',
        method: 'post',
        data,
    })
}